import ___default from "lodash";
import { registerIcons } from "@fluentui/style-utilities";
import { UnknownErrorIcon } from "../icons/UnknownErrorIcon.js";
import { SomethingWentWrongIcon } from "../icons/SomethingWentWrongIcon.js";
import { AccessDeniedIcon } from "../icons/AccessDeniedIcon.js";
import { NoResultsAvailableIcon } from "../icons/NoResultsAvailableIcon.js";
import { NotificationEmptyIcon } from "../icons/NotificationEmptyIcon.js";
import { NotificationErrorIcon } from "../icons/NotificationErrorIcon.js";
import { SessionExpiredIcon } from "../icons/SessionExpiredIcon.js";
import { WorkspaceNotFoundIcon } from "../icons/WorkspaceNotFoundIcon.js";
var ICON_NAMES = /* @__PURE__ */ ((ICON_NAMES2) => {
  ICON_NAMES2["UnknownError"] = "UnknownError";
  ICON_NAMES2["SomethingWentWrong"] = "SomethingWentWrong";
  ICON_NAMES2["AccessDenied"] = "AccessDenied";
  ICON_NAMES2["NoResultsAvailable"] = "NoResultsAvailable";
  ICON_NAMES2["NotificationEmpty"] = "NotificationEmpty";
  ICON_NAMES2["NotificationError"] = "NotificationError";
  ICON_NAMES2["SessionExpired"] = "SessionExpired";
  ICON_NAMES2["WorkspaceNotFound"] = "WorkspaceNotFound";
  ICON_NAMES2["VpnError"] = "VpnError";
  return ICON_NAMES2;
})(ICON_NAMES || {});
function registerIcon() {
  registerIcons({
    icons: {
      /**
       * TODO msal
       * update icon
       */
      [
        "UnknownError"
        /* UnknownError */
      ]: UnknownErrorIcon(),
      [
        "SomethingWentWrong"
        /* SomethingWentWrong */
      ]: SomethingWentWrongIcon(),
      [
        "AccessDenied"
        /* AccessDenied */
      ]: AccessDeniedIcon(),
      [
        "NoResultsAvailable"
        /* NoResultsAvailable */
      ]: NoResultsAvailableIcon(),
      [
        "NotificationEmpty"
        /* NotificationEmpty */
      ]: NotificationEmptyIcon(),
      [
        "NotificationError"
        /* NotificationError */
      ]: NotificationErrorIcon(),
      [
        "SessionExpired"
        /* SessionExpired */
      ]: SessionExpiredIcon(),
      [
        "WorkspaceNotFound"
        /* WorkspaceNotFound */
      ]: WorkspaceNotFoundIcon(),
      [
        "VpnError"
        /* VpnError */
      ]: ""
    }
  });
}
const RegisterIcons = ___default.once(registerIcon);
export {
  ICON_NAMES,
  RegisterIcons
};
//# sourceMappingURL=registerIcons.js.map
